export default {
  "Studies available": "Estudos disponíveis",
  "Studies limit about":
    "O número de estudos que podem ser processados é limitado. Para aumentar o limite, entre em contato com seu gerente ou com sales@3opinion.ai",
  "Studies limit reached":
    "Limite de processamento de estudos atingido. Para aumentar o limite, entre em contato com seu gerente ou com sales@3opinion.ai",
  "Wait for upload": "Aguarde o término do carregamento atual",
  Upload: "Carregar",
  directory: "Carregar pasta",
  zip: "Carregar arquivos",
  gender: "Sexo, \n idade",
  Name: "Nome",
  Status: "Status de processamento",
  studyDate: "Data do estudo",
  uploadDate: "Data de envio",
  "Dicom count": "Imagens",
  Action: "Ação",
  Delete: "Excluir",
  "Delete confirm": "Tem certeza de que deseja excluir o estudo?",
  "Delete confirm about":
    "Ao excluir, o limite de processamento de estudos não será alterado",
  "No studies": "Nenhum estudo",
  Search: "Pesquisar",
  Cancel: "Cancelar",
  "Study status none": "Não iniciado",
  "Study status proccess": "Em processo",
  "Study status not_found": "Nenhuma patologia encontrada",
  "Study status found": "Patologias encontradas",
  Wait: "Aguardando",
  "Zip processed": "Compactando",
  Done: "Concluído",
  "Success upload":
    "Arquivos carregados com sucesso. Aguarde a atualização da lista de estudos",
  "Upload error": "Servidor indisponível, tente novamente mais tarde",
  "Reach files size":
    "Carregamento não possível. O tamanho total dos arquivos excede o permitido",
  "Upload process": "Processando",
  Yes: "Sim",
  No: "Não",
  "Study in queue": "Na fila",
  "Study in proccess": "Processando",
  "Study not found": "Nenhuma patologia encontrada",
  "Study found": "Patologias encontradas",
  "Study error": "Erro de processamento",
  "Study error about": "Erro de envio, tente enviar o estudo novamente",
  patientID: "ID do paciente",
  male_short: "M",
  female_short: "F",
  "Wait for anonimization": "Anonimizando",
  "Wait for loading": "Carregando",
  "Studies title": "Lista de estudos | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload": "O formato dos arquivos carregados não atende aos requisitos",
  undefined__error:
    "O formato dos arquivos carregados não atende aos requisitos",
  good: "Bom",
  step0:
    "Você pode carregar uma pasta com estudos, o serviço irá anonimizar e processar com inteligência artificial",
  step1:
    "Seus estudos estão sendo carregados, <br> isso pode levar alguns minutos. <br><br> O carregamento ocorre em segundo plano, você pode visualizar outros estudos enquanto isso.",
  step2:
    "O estudo processado pela IA aparecerá aqui. <br><br> O processamento pode levar alguns minutos e ocorre em segundo plano. Durante esse tempo, você pode visualizar outros estudos.",
  "Demo Upload text": "Você poderá processar seus estudos após o registro",
  Register: "Registrar",
  "Demo Banner Text":
    "Crie uma conta e obtenha acesso completo aos serviços de IA e cursos educacionais",
  Okay: "Entendi",
  "Mobile Notification":
    "Ao visualizar o site em um dispositivo móvel, a funcionalidade é limitada.<br> Para acesso total, abra o site em um computador.",
  "Studies limit Demo about":
    "Você poderá processar seus estudos no painel pessoal após o registro",
  "Dicom count v2": "Cortes",
  prev: "Anterior",
  next: "Próximo",
  "Files select": "Arquivos selecionados",
  "Access files": "Compatíveis com o serviço",
  "Access files about": "Estão sendo carregados para análise por IA",
  "Skip files": "Incompatíveis",
  "Tags values": "Valores das tags",
  "Skip files about": "não atendem aos requisitos do serviço",
  Check: "Verificar",
  "Status short": "Status",
  More: "Ampliar",
  TagError: {
    tail: "<br><br> Selecione outro estudo ou <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>contate o suporte técnico</a>",
    not_exist: "Tag <TAG> do estudo não especificada",
    some_error:
      "Tag <TAG> com valor <TAG_VALUE> não atende aos requisitos do serviço <RULES>",
    PatientsAge: "Idade do paciente inferior a 18 anos",
    Modality: "Modalidade",
    SliceThickness: "Espessura do corte",
    BodyPartExamined: "Parte do corpo examinada",
    StudyInstanceUID: "UID da instância do estudo",
    SeriesInstanceUID: "UID da instância da série",
  },
};
